/**
 * All possible return codes from the API.
 * This should match ApiReturnCodes.cs in Patchwork.Shared.
 */
export const PatchworkApiReturnCodes = {
	OK: 0,
	NOK: 1,
	INTERNALSERVERERROR: 2,
	RESULTISNULLEXCEPTION: 4,
	INVALIDLOGINTOKENEXCEPTION: 5,
	INVALIDREFRESHTOKENEXCEPTION: 6,
	REFRESHTOKENCREATIONEXCEPTION: 7,
	USEREXISTSEXCEPTION: 8,
	USERDOESNOTEXISTEXCEPTION: 9,
	USERMAILNOTVERIFIEDEXCEPTION: 10,
	USERCREATIONEXCEPTION: 11,
	USERLOGINCREATIONEXCEPTION: 12,
	USERDELETIONEXCEPTION: 13,
	USERUPDATEEXCEPTION: 14,
	INVALIDCREDENTIALEXCEPTION: 15,
	MAILVALIDATIONLINKDOESNOTEXISTEXCEPTION: 16,
	MAILVALIDATIONLINKDELETIONEXCEPTION: 17,
	MAILVALIDATIONLINKCREATIONEXCEPTION: 18,
	PASSWORDLINKDELETIONEXCEPTION: 19,
	PASSWORDLINKDOESNOTEXISTEXCEPTION: 20,
	PASSWORDHASHEXCEPTION: 21,
	INVALIDB64UUIDFORMATEXCEPTION: 22,
	POSTGRESEXCEPTIONSUCCESSFULCOMPLETION: 23,
	POSTGRESEXCEPTIONWARNING: 24,
	POSTGRESEXCEPTIONDYNAMICRESULTSETSRETURNED: 25,
	POSTGRESEXCEPTIONIMPLICITZEROBITPADDING: 26,
	POSTGRESEXCEPTIONNULLVALUEELIMINATEDINSETFUNCTION: 27,
	POSTGRESEXCEPTIONPRIVILEGENOTGRANTED: 28,
	POSTGRESEXCEPTIONPRIVILEGENOTREVOKED: 29,
	POSTGRESEXCEPTIONSTRINGDATARIGHTTRUNCATION_01004: 30,
	POSTGRESEXCEPTIONDEPRECATEDFEATURE: 31,
	POSTGRESEXCEPTIONNODATA: 32,
	POSTGRESEXCEPTIONNOADDITIONALDYNAMICRESULTSETSRETURNED: 33,
	POSTGRESEXCEPTIONSQLSTATEMENTNOTYETCOMPLETE: 34,
	POSTGRESEXCEPTIONCONNECTIONEXCEPTION: 35,
	POSTGRESEXCEPTIONCONNECTIONDOESNOTEXIST: 36,
	POSTGRESEXCEPTIONCONNECTIONFAILURE: 37,
	POSTGRESEXCEPTIONSQLCLIENTUNABLETOESTABLISHSQLCONNECTION: 38,
	POSTGRESEXCEPTIONSQLSERVERREJECTEDESTABLISHMENTOFSQLCONNECTION: 39,
	POSTGRESEXCEPTIONTRANSACTIONRESOLUTIONUNKNOWN: 40,
	POSTGRESEXCEPTIONPROTOCOLVIOLATION: 41,
	POSTGRESEXCEPTIONTRIGGEREDACTIONEXCEPTION: 42,
	POSTGRESEXCEPTIONFEATURENOTSUPPORTED: 43,
	POSTGRESEXCEPTIONINVALIDTRANSACTIONINITIATION: 44,
	POSTGRESEXCEPTIONLOCATOREXCEPTION: 45,
	POSTGRESEXCEPTIONINVALIDLOCATORSPECIFICATION: 46,
	POSTGRESEXCEPTIONINVALIDGRANTOR: 47,
	POSTGRESEXCEPTIONINVALIDGRANTOPERATION: 48,
	POSTGRESEXCEPTIONINVALIDROLESPECIFICATION: 49,
	POSTGRESEXCEPTIONDIAGNOSTICSEXCEPTION: 50,
	POSTGRESEXCEPTIONSTACKEDDIAGNOSTICSACCESSEDWITHOUTACTIVEHANDLER: 51,
	POSTGRESEXCEPTIONINVALIDARGUMENTFORXQUERY: 52,
	POSTGRESEXCEPTIONCASENOTFOUND: 53,
	POSTGRESEXCEPTIONCARDINALITYVIOLATION: 54,
	POSTGRESEXCEPTIONDATAEXCEPTION: 55,
	POSTGRESEXCEPTIONARRAYSUBSCRIPTERROR: 56,
	POSTGRESEXCEPTIONCHARACTERNOTINREPERTOIRE: 57,
	POSTGRESEXCEPTIONDATETIMEFIELDOVERFLOW: 58,
	POSTGRESEXCEPTIONDIVISIONBYZERO: 59,
	POSTGRESEXCEPTIONERRORINASSIGNMENT: 60,
	POSTGRESEXCEPTIONESCAPECHARACTERCONFLICT: 61,
	POSTGRESEXCEPTIONINDICATOROVERFLOW: 62,
	POSTGRESEXCEPTIONINTERVALFIELDOVERFLOW: 63,
	POSTGRESEXCEPTIONINVALIDARGUMENTFORLOGARITHM: 64,
	POSTGRESEXCEPTIONINVALIDARGUMENTFORNTILEFUNCTION: 65,
	POSTGRESEXCEPTIONINVALIDARGUMENTFORNTHVALUEFUNCTION: 66,
	POSTGRESEXCEPTIONINVALIDARGUMENTFORPOWERFUNCTION: 67,
	POSTGRESEXCEPTIONINVALIDARGUMENTFORWIDTHBUCKETFUNCTION: 68,
	POSTGRESEXCEPTIONINVALIDCHARACTERVALUEFORCAST: 69,
	POSTGRESEXCEPTIONINVALIDDATETIMEFORMAT: 70,
	POSTGRESEXCEPTIONINVALIDESCAPECHARACTER: 71,
	POSTGRESEXCEPTIONINVALIDESCAPEOCTET: 72,
	POSTGRESEXCEPTIONINVALIDESCAPESEQUENCE: 73,
	POSTGRESEXCEPTIONNONSTANDARDUSEOFESCAPECHARACTER: 74,
	POSTGRESEXCEPTIONINVALIDINDICATORPARAMETERVALUE: 75,
	POSTGRESEXCEPTIONINVALIDPARAMETERVALUE: 76,
	POSTGRESEXCEPTIONINVALIDPRECEDINGORFOLLOWINGSIZE: 77,
	POSTGRESEXCEPTIONINVALIDREGULAREXPRESSION: 78,
	POSTGRESEXCEPTIONINVALIDROWCOUNTINLIMITCLAUSE: 79,
	POSTGRESEXCEPTIONINVALIDROWCOUNTINRESULTOFFSETCLAUSE: 80,
	POSTGRESEXCEPTIONINVALIDTABLESAMPLEARGUMENT: 81,
	POSTGRESEXCEPTIONINVALIDTABLESAMPLEREPEAT: 82,
	POSTGRESEXCEPTIONINVALIDTIMEZONEDISPLACEMENTVALUE: 83,
	POSTGRESEXCEPTIONINVALIDUSEOFESCAPECHARACTER: 84,
	POSTGRESEXCEPTIONMOSTSPECIFICTYPEMISMATCH: 85,
	POSTGRESEXCEPTIONNULLVALUENOTALLOWED_22004: 86,
	POSTGRESEXCEPTIONNULLVALUENOINDICATORPARAMETER: 87,
	POSTGRESEXCEPTIONNUMERICVALUEOUTOFRANGE: 88,
	POSTGRESEXCEPTIONSEQUENCEGENERATORLIMITEXCEEDED: 89,
	POSTGRESEXCEPTIONSTRINGDATALENGTHMISMATCH: 90,
	POSTGRESEXCEPTIONSTRINGDATARIGHTTRUNCATION_22001: 91,
	POSTGRESEXCEPTIONSUBSTRINGERROR: 92,
	POSTGRESEXCEPTIONTRIMERROR: 93,
	POSTGRESEXCEPTIONUNTERMINATEDCSTRING: 94,
	POSTGRESEXCEPTIONZEROLENGTHCHARACTERSTRING: 95,
	POSTGRESEXCEPTIONFLOATINGPOINTEXCEPTION: 96,
	POSTGRESEXCEPTIONINVALIDTEXTREPRESENTATION: 97,
	POSTGRESEXCEPTIONINVALIDBINARYREPRESENTATION: 98,
	POSTGRESEXCEPTIONBADCOPYFILEFORMAT: 99,
	POSTGRESEXCEPTIONUNTRANSLATABLECHARACTER: 100,
	POSTGRESEXCEPTIONNOTANXMLDOCUMENT: 101,
	POSTGRESEXCEPTIONINVALIDXMLDOCUMENT: 102,
	POSTGRESEXCEPTIONINVALIDXMLCONTENT: 103,
	POSTGRESEXCEPTIONINVALIDXMLCOMMENT: 104,
	POSTGRESEXCEPTIONINVALIDXMLPROCESSINGINSTRUCTION: 105,
	POSTGRESEXCEPTIONDUPLICATEJSONOBJECTKEYVALUE: 106,
	POSTGRESEXCEPTIONINVALIDARGUMENTFORSQLJSONDATETIMEFUNCTION: 107,
	POSTGRESEXCEPTIONINVALIDJSONTEXT: 108,
	POSTGRESEXCEPTIONINVALIDSQLJSONSUBSCRIPT: 109,
	POSTGRESEXCEPTIONMORETHANONESQLJSONITEM: 110,
	POSTGRESEXCEPTIONNOSQLJSONITEM: 111,
	POSTGRESEXCEPTIONNONNUMERICSQLJSONITEM: 112,
	POSTGRESEXCEPTIONNONUNIQUEKEYSINAJSONOBJECT: 113,
	POSTGRESEXCEPTIONSINGLETONSQLJSONITEMREQUIRED: 114,
	POSTGRESEXCEPTIONSQLJSONARRAYNOTFOUND: 115,
	POSTGRESEXCEPTIONSQLJSONMEMBERNOTFOUND: 116,
	POSTGRESEXCEPTIONSQLJSONNUMBERNOTFOUND: 117,
	POSTGRESEXCEPTIONSQLJSONOBJECTNOTFOUND: 118,
	POSTGRESEXCEPTIONTOOMANYJSONARRAYELEMENTS: 119,
	POSTGRESEXCEPTIONTOOMANYJSONOBJECTMEMBERS: 120,
	POSTGRESEXCEPTIONSQLJSONSCALARREQUIRED: 121,
	POSTGRESEXCEPTIONSQLJSONITEMCANNOTBECASTTOTARGETTYPE: 122,
	POSTGRESEXCEPTIONINTEGRITYCONSTRAINTVIOLATION: 123,
	POSTGRESEXCEPTIONRESTRICTVIOLATION: 124,
	POSTGRESEXCEPTIONNOTNULLVIOLATION: 125,
	POSTGRESEXCEPTIONFOREIGNKEYVIOLATION: 126,
	POSTGRESEXCEPTIONUNIQUEVIOLATION: 127,
	POSTGRESEXCEPTIONCHECKVIOLATION: 128,
	POSTGRESEXCEPTIONEXCLUSIONVIOLATION: 129,
	POSTGRESEXCEPTIONINVALIDCURSORSTATE: 130,
	POSTGRESEXCEPTIONINVALIDTRANSACTIONSTATE: 131,
	POSTGRESEXCEPTIONACTIVESQLTRANSACTION: 132,
	POSTGRESEXCEPTIONBRANCHTRANSACTIONALREADYACTIVE: 133,
	POSTGRESEXCEPTIONHELDCURSORREQUIRESSAMEISOLATIONLEVEL: 134,
	POSTGRESEXCEPTIONINAPPROPRIATEACCESSMODEFORBRANCHTRANSACTION: 135,
	POSTGRESEXCEPTIONINAPPROPRIATEISOLATIONLEVELFORBRANCHTRANSACTION: 136,
	POSTGRESEXCEPTIONNOACTIVESQLTRANSACTIONFORBRANCHTRANSACTION: 137,
	POSTGRESEXCEPTIONREADONLYSQLTRANSACTION: 138,
	POSTGRESEXCEPTIONSCHEMAANDDATASTATEMENTMIXINGNOTSUPPORTED: 139,
	POSTGRESEXCEPTIONNOACTIVESQLTRANSACTION: 140,
	POSTGRESEXCEPTIONINFAILEDSQLTRANSACTION: 141,
	POSTGRESEXCEPTIONIDLEINTRANSACTIONSESSIONTIMEOUT: 142,
	POSTGRESEXCEPTIONTRANSACTIONTIMEOUT: 143,
	POSTGRESEXCEPTIONINVALIDSQLSTATEMENTNAME: 144,
	POSTGRESEXCEPTIONTRIGGEREDDATACHANGEVIOLATION: 145,
	POSTGRESEXCEPTIONINVALIDAUTHORIZATIONSPECIFICATION: 146,
	POSTGRESEXCEPTIONINVALIDPASSWORD: 147,
	POSTGRESEXCEPTIONDEPENDENTPRIVILEGEDESCRIPTORSSTILLEXIST: 148,
	POSTGRESEXCEPTIONDEPENDENTOBJECTSSTILLEXIST: 149,
	POSTGRESEXCEPTIONINVALIDTRANSACTIONTERMINATION: 150,
	POSTGRESEXCEPTIONSQLROUTINEEXCEPTION: 151,
	POSTGRESEXCEPTIONFUNCTIONEXECUTEDNORETURNSTATEMENT: 152,
	POSTGRESEXCEPTIONMODIFYINGSQLDATANOTPERMITTED_2F002: 153,
	POSTGRESEXCEPTIONPROHIBITEDSQLSTATEMENTATTEMPTED_2F003: 154,
	POSTGRESEXCEPTIONREADINGSQLDATANOTPERMITTED_2F004: 155,
	POSTGRESEXCEPTIONINVALIDCURSORNAME: 156,
	POSTGRESEXCEPTIONEXTERNALROUTINEEXCEPTION: 157,
	POSTGRESEXCEPTIONCONTAININGSQLNOTPERMITTED: 158,
	POSTGRESEXCEPTIONMODIFYINGSQLDATANOTPERMITTED_38002: 159,
	POSTGRESEXCEPTIONPROHIBITEDSQLSTATEMENTATTEMPTED_38003: 160,
	POSTGRESEXCEPTIONREADINGSQLDATANOTPERMITTED_38004: 161,
	POSTGRESEXCEPTIONEXTERNALROUTINEINVOCATIONEXCEPTION: 162,
	POSTGRESEXCEPTIONINVALIDSQLSTATERETURNED: 163,
	POSTGRESEXCEPTIONNULLVALUENOTALLOWED_39004: 164,
	POSTGRESEXCEPTIONTRIGGERPROTOCOLVIOLATED: 165,
	POSTGRESEXCEPTIONSRFPROTOCOLVIOLATED: 166,
	POSTGRESEXCEPTIONEVENTTRIGGERPROTOCOLVIOLATED: 167,
	POSTGRESEXCEPTIONSAVEPOINTEXCEPTION: 168,
	POSTGRESEXCEPTIONINVALIDSAVEPOINTSPECIFICATION: 169,
	POSTGRESEXCEPTIONINVALIDCATALOGNAME: 170,
	POSTGRESEXCEPTIONINVALIDSCHEMANAME: 171,
	POSTGRESEXCEPTIONTRANSACTIONROLLBACK: 172,
	POSTGRESEXCEPTIONTRANSACTIONINTEGRITYCONSTRAINTVIOLATION: 173,
	POSTGRESEXCEPTIONSERIALIZATIONFAILURE: 174,
	POSTGRESEXCEPTIONSTATEMENTCOMPLETIONUNKNOWN: 175,
	POSTGRESEXCEPTIONDEADLOCKDETECTED: 176,
	POSTGRESEXCEPTIONSYNTAXERRORORACCESSRULEVIOLATION: 177,
	POSTGRESEXCEPTIONSYNTAXERROR: 178,
	POSTGRESEXCEPTIONINSUFFICIENTPRIVILEGE: 179,
	POSTGRESEXCEPTIONCANNOTCOERCE: 180,
	POSTGRESEXCEPTIONGROUPINGERROR: 181,
	POSTGRESEXCEPTIONWINDOWINGERROR: 182,
	POSTGRESEXCEPTIONINVALIDRECURSION: 183,
	POSTGRESEXCEPTIONINVALIDFOREIGNKEY: 184,
	POSTGRESEXCEPTIONINVALIDNAME: 185,
	POSTGRESEXCEPTIONNAMETOOLONG: 186,
	POSTGRESEXCEPTIONRESERVEDNAME: 187,
	POSTGRESEXCEPTIONDATATYPEMISMATCH: 188,
	POSTGRESEXCEPTIONINDETERMINATEDATATYPE: 189,
	POSTGRESEXCEPTIONCOLLATIONMISMATCH: 190,
	POSTGRESEXCEPTIONINDETERMINATECOLLATION: 191,
	POSTGRESEXCEPTIONWRONGOBJECTTYPE: 192,
	POSTGRESEXCEPTIONGENERATEDALWAYS: 193,
	POSTGRESEXCEPTIONUNDEFINEDCOLUMN: 194,
	POSTGRESEXCEPTIONUNDEFINEDFUNCTION: 195,
	POSTGRESEXCEPTIONUNDEFINEDTABLE: 196,
	POSTGRESEXCEPTIONUNDEFINEDPARAMETER: 197,
	POSTGRESEXCEPTIONUNDEFINEDOBJECT: 198,
	POSTGRESEXCEPTIONDUPLICATECOLUMN: 199,
	POSTGRESEXCEPTIONDUPLICATECURSOR: 200,
	POSTGRESEXCEPTIONDUPLICATEDATABASE: 201,
	POSTGRESEXCEPTIONDUPLICATEFUNCTION: 202,
	POSTGRESEXCEPTIONDUPLICATEPREPAREDSTATEMENT: 203,
	POSTGRESEXCEPTIONDUPLICATESCHEMA: 204,
	POSTGRESEXCEPTIONDUPLICATETABLE: 205,
	POSTGRESEXCEPTIONDUPLICATEALIAS: 206,
	POSTGRESEXCEPTIONDUPLICATEOBJECT: 207,
	POSTGRESEXCEPTIONAMBIGUOUSCOLUMN: 208,
	POSTGRESEXCEPTIONAMBIGUOUSFUNCTION: 209,
	POSTGRESEXCEPTIONAMBIGUOUSPARAMETER: 210,
	POSTGRESEXCEPTIONAMBIGUOUSALIAS: 211,
	POSTGRESEXCEPTIONINVALIDCOLUMNREFERENCE: 212,
	POSTGRESEXCEPTIONINVALIDCOLUMNDEFINITION: 213,
	POSTGRESEXCEPTIONINVALIDCURSORDEFINITION: 214,
	POSTGRESEXCEPTIONINVALIDDATABASEDEFINITION: 215,
	POSTGRESEXCEPTIONINVALIDFUNCTIONDEFINITION: 216,
	POSTGRESEXCEPTIONINVALIDPREPAREDSTATEMENTDEFINITION: 217,
	POSTGRESEXCEPTIONINVALIDSCHEMADEFINITION: 218,
	POSTGRESEXCEPTIONINVALIDTABLEDEFINITION: 219,
	POSTGRESEXCEPTIONINVALIDOBJECTDEFINITION: 220,
	POSTGRESEXCEPTIONWITHCHECKOPTIONVIOLATION: 221,
	POSTGRESEXCEPTIONINSUFFICIENTRESOURCES: 222,
	POSTGRESEXCEPTIONDISKFULL: 223,
	POSTGRESEXCEPTIONOUTOFMEMORY: 224,
	POSTGRESEXCEPTIONTOOMANYCONNECTIONS: 225,
	POSTGRESEXCEPTIONCONFIGURATIONLIMITEXCEEDED: 226,
	POSTGRESEXCEPTIONPROGRAMLIMITEXCEEDED: 227,
	POSTGRESEXCEPTIONSTATEMENTTOOCOMPLEX: 228,
	POSTGRESEXCEPTIONTOOMANYCOLUMNS: 229,
	POSTGRESEXCEPTIONTOOMANYARGUMENTS: 230,
	POSTGRESEXCEPTIONOBJECTNOTINPREREQUISITESTATE: 231,
	POSTGRESEXCEPTIONOBJECTINUSE: 232,
	POSTGRESEXCEPTIONCANTCHANGERUNTIMEPARAM: 233,
	POSTGRESEXCEPTIONLOCKNOTAVAILABLE: 234,
	POSTGRESEXCEPTIONUNSAFENEWENUMVALUEUSAGE: 235,
	POSTGRESEXCEPTIONOPERATORINTERVENTION: 236,
	POSTGRESEXCEPTIONQUERYCANCELED: 237,
	POSTGRESEXCEPTIONADMINSHUTDOWN: 238,
	POSTGRESEXCEPTIONCRASHSHUTDOWN: 239,
	POSTGRESEXCEPTIONCANNOTCONNECTNOW: 240,
	POSTGRESEXCEPTIONDATABASEDROPPED: 241,
	POSTGRESEXCEPTIONIDLESESSIONTIMEOUT: 242,
	POSTGRESEXCEPTIONSYSTEMERROR: 243,
	POSTGRESEXCEPTIONIOERROR: 244,
	POSTGRESEXCEPTIONUNDEFINEDFILE: 245,
	POSTGRESEXCEPTIONDUPLICATEFILE: 246,
	POSTGRESEXCEPTIONFILENAMETOOLONG: 247,
	POSTGRESEXCEPTIONCONFIGFILEERROR: 248,
	POSTGRESEXCEPTIONLOCKFILEEXISTS: 249,
	POSTGRESEXCEPTIONFDWERROR: 250,
	POSTGRESEXCEPTIONFDWCOLUMNNAMENOTFOUND: 251,
	POSTGRESEXCEPTIONFDWDYNAMICPARAMETERVALUENEEDED: 252,
	POSTGRESEXCEPTIONFDWFUNCTIONSEQUENCEERROR: 253,
	POSTGRESEXCEPTIONFDWINCONSISTENTDESCRIPTORINFORMATION: 254,
	POSTGRESEXCEPTIONFDWINVALIDATTRIBUTEVALUE: 255,
	POSTGRESEXCEPTIONFDWINVALIDCOLUMNNAME: 256,
	POSTGRESEXCEPTIONFDWINVALIDCOLUMNNUMBER: 257,
	POSTGRESEXCEPTIONFDWINVALIDDATATYPE: 258,
	POSTGRESEXCEPTIONFDWINVALIDDATATYPEDESCRIPTORS: 259,
	POSTGRESEXCEPTIONFDWINVALIDDESCRIPTORFIELDIDENTIFIER: 260,
	POSTGRESEXCEPTIONFDWINVALIDHANDLE: 261,
	POSTGRESEXCEPTIONFDWINVALIDOPTIONINDEX: 262,
	POSTGRESEXCEPTIONFDWINVALIDOPTIONNAME: 263,
	POSTGRESEXCEPTIONFDWINVALIDSTRINGLENGTHORBUFFERLENGTH: 264,
	POSTGRESEXCEPTIONFDWINVALIDSTRINGFORMAT: 265,
	POSTGRESEXCEPTIONFDWINVALIDUSEOFNULLPOINTER: 266,
	POSTGRESEXCEPTIONFDWTOOMANYHANDLES: 267,
	POSTGRESEXCEPTIONFDWOUTOFMEMORY: 268,
	POSTGRESEXCEPTIONFDWNOSCHEMAS: 269,
	POSTGRESEXCEPTIONFDWOPTIONNAMENOTFOUND: 270,
	POSTGRESEXCEPTIONFDWREPLYHANDLE: 271,
	POSTGRESEXCEPTIONFDWSCHEMANOTFOUND: 272,
	POSTGRESEXCEPTIONFDWTABLENOTFOUND: 273,
	POSTGRESEXCEPTIONFDWUNABLETOCREATEEXECUTION: 274,
	POSTGRESEXCEPTIONFDWUNABLETOCREATEREPLY: 275,
	POSTGRESEXCEPTIONFDWUNABLETOESTABLISHCONNECTION: 276,
	POSTGRESEXCEPTIONPLPGSQLERROR: 277,
	POSTGRESEXCEPTIONRAISEEXCEPTION: 278,
	POSTGRESEXCEPTIONNODATAFOUND: 279,
	POSTGRESEXCEPTIONTOOMANYROWS: 280,
	POSTGRESEXCEPTIONASSERTFAILURE: 281,
	POSTGRESEXCEPTIONINTERNALERROR: 282,
	POSTGRESEXCEPTIONDATACORRUPTED: 283,
	POSTGRESEXCEPTIONINDEXCORRUPTED: 284,
} as const;
export type PatchworkApiReturnCodes = typeof PatchworkApiReturnCodes[keyof typeof PatchworkApiReturnCodes];

/**
 * Structure that match the error structure returned by the Patchwork API
 */
export class PatchworkApiError {
	error : string = "";
	errorCode : PatchworkApiReturnCodes = PatchworkApiReturnCodes.NOK;
}

export class PatchworkRESTApiError extends Error {
	errorCode : PatchworkApiReturnCodes = PatchworkApiReturnCodes.NOK;
	constructor(err : PatchworkApiError, ...params: any[]) {
		super(...params);
		this.message = err.error;
		this.errorCode = err.errorCode;
		this.name = "PatchworkRESTApiError";
	}
}

